module.exports = __webpack_public_path__ + "static/media/image_3.7aac8bae.png";